import { FC, useMemo } from 'react'
import { IntlProvider } from 'react-intl'
import { OnErrorFn } from '@formatjs/intl'
import { objectToDotNotation } from '@app/lib/utils'
import { translations } from './translations'

const defaultLanguage = 'en'

export const LocaleProvider: FC<{ children?: React.ReactNode }> = (props) => {
	const userLocale =
		typeof navigator !== 'undefined' ? navigator.language : undefined

	const language = userLocale
		? userLocale.split('-')[0] // 'en-US' -> 'en'
		: defaultLanguage

	const translationsLanguage = Object.keys(translations).includes(language)
		? language
		: defaultLanguage

	const messages = useMemo(
		() =>
			objectToDotNotation(
				translations[translationsLanguage as keyof typeof translations]
			),
		[translationsLanguage]
	)

	const onError: OnErrorFn = (err) => {
		if (err.code === 'MISSING_TRANSLATION') {
			if (process.env.NODE_ENV === 'development') {
				console.warn(err.message)
			}
		} else {
			throw err
		}
	}

	return (
		<IntlProvider
			locale={defaultLanguage}
			messages={messages}
			onError={onError}
		>
			{props.children}
		</IntlProvider>
	)
}
